import { render, staticRenderFns } from "./ActiveCodeStats.vue?vue&type=template&id=467cbc7a&scoped=true&"
import script from "./ActiveCodeStats.vue?vue&type=script&lang=js&"
export * from "./ActiveCodeStats.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCodeStats.vue?vue&type=style&index=0&id=467cbc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cbc7a",
  null
  
)

export default component.exports